// extracted by mini-css-extract-plugin
export default {"socialMidia":"dt__zs_vuDmT4dVYRiW_","iconContainer":"QDXHXTe4FzBCbMuIaRdd","icon":"eT_NxCvoHyPQBiwjr_1_"};